import { toCamelCaseProperties } from '@/utils/fn';

export default class Chain {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};

		this.chainFixitSiteId = args.chainFixitSiteId || 0;
		this.chainId = args.chainId || 0;
		this.cmsReturnUrl = args.cmsReturnUrl || '';
		this.defaultSiteId = args.defaultSiteId || 0;
		this.giftcardActive = !!args.giftcardActive;
		this.giftcardApprovedByOdin = !!args.giftcardApprovedByOdin;
		this.imageUrl = args.imageUrl || '';
		this.name = args.name || '';
		this.owbThemeFolder = args.owbThemeFolder || null;
		this.siteWebUrl = args.siteWebUrl || '';
	}
}
